module.exports = __webpack_public_path__ + "img/pen-clip.f05398b4.svg";